import {
    createEntityAdapter,
    EntityAdapter,
    EntityState
} from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { EmployeeBaseRateStateItem } from './employee-base-rate.model';
import * as EmployeeBaseRateActions from './employee-base-rate.actions';

export const employeeBaseRatesFeatureKey = 'employeeBaseRates';

export interface State extends EntityState<EmployeeBaseRateStateItem> {}

export const adapter: EntityAdapter<EmployeeBaseRateStateItem> =
    createEntityAdapter<EmployeeBaseRateStateItem>({
        selectId: (row: EmployeeBaseRateStateItem) => row.EmployeeListID
    });

export const initialState: State = adapter.getInitialState({});

const employeeBaseRateReducer = createReducer(
    initialState,
    on(EmployeeBaseRateActions.loadEmployeeBaseRates, (state, action) =>
        adapter.setAll(action.rows, state)
    ),
    on(EmployeeBaseRateActions.upsertEmployeeBaseRate, (state, action) =>
        adapter.upsertOne(action.row, state)
    ),
    on(EmployeeBaseRateActions.clearEmployeeBaseRates, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return employeeBaseRateReducer(state, action);
}
